exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".fliwas-header{position:sticky;top:0;display:flex;flex-direction:row;align-items:center;justify-content:space-between;padding:16px;color:#fff;background-color:#326487;box-shadow:0 0 4px #333301;margin-bottom:16px;z-index:1}@media (min-width:768px){.fliwas-header{color:#326487;background-color:#fff;box-shadow:none;margin-bottom:0}}.fliwas-header__button{height:32px;width:32px;padding:0;margin-bottom:0;border-color:#fff;color:#fff;display:flex;align-items:center;justify-content:center}.fliwas-header__button:hover{color:#fff}@media (min-width:768px){.fliwas-header__button-close{display:none}}.fliwas-header__close-icon{font-size:20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /builds/landesanstalt-fuer-umwelt-baden-wuerttemberg/fliwas/fliwas-three/~/css-loader!/builds/landesanstalt-fuer-umwelt-baden-wuerttemberg/fliwas/fliwas-three/~/sass-loader!./js/css/_header.scss
// module id = 149
// module chunks = 3